import { usePage } from "@inertiajs/react";
import CommunitiesLayout from "./Layout";
import UserProfileApp from "../../communities/pages/user-profile/App";

function UserProfile() {
  const { slug } = usePage().props;
  return <UserProfileApp slug={slug} />;
}
UserProfile.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>;
export default UserProfile;
